var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.45 319.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#6b7b84;}.cls-3{fill:#231f20;}.cls-4{fill:#812990;}.cls-5{fill:none;stroke:#ffcb05;stroke-miterlimit:10;stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 382.9,
    y1: 301.35,
    x2: 425.32,
    y2: 301.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "382.9 319.02 404.11 283.67 425.32 319.02 382.9 319.02"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.23,310.34v.55h-2.4v-3.13h2.31v.55H18.45v.79h1.41v.54H18.45v.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.59,307.54v3.35H23v-.15a1.38,1.38,0,0,1-.7.19,1.25,1.25,0,0,1,0-2.5,1.46,1.46,0,0,1,.7.19v-1.08ZM23,310.16v-1a1,1,0,0,0-.59-.2.69.69,0,0,0-.72.69.68.68,0,0,0,.72.69A.9.9,0,0,0,23,310.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.93,308.48v2.41h-.62v-.16a1.19,1.19,0,0,1-.66.19c-.7,0-1-.33-1-1.11v-1.33h.62v1.33c0,.38.18.56.52.56a.81.81,0,0,0,.55-.19v-1.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.12,310.44a1.14,1.14,0,0,1-.93.48,1.25,1.25,0,1,1,0-2.49,1.17,1.17,0,0,1,.94.48l-.4.37a.65.65,0,0,0-.54-.29.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.47,308.48v2.41h-.61v-.18a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.46,1.46,0,0,1,.71.2v-.15Zm-.61.72a1,1,0,0,0-.6-.21.69.69,0,1,0,0,1.38.93.93,0,0,0,.6-.21Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.29,309v.85c0,.43.07.56.38.56a2,2,0,0,0,.28,0v.46a1.42,1.42,0,0,1-.56.09.7.7,0,0,1-.73-.76V309h-.34v-.51h.34v-.94h.63v.94H36V309Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.83,307.86a.36.36,0,1,1,.71,0,.36.36,0,1,1-.71,0Zm.05.62h.61v2.41h-.61Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.09,309.68a1.32,1.32,0,1,1-1.32-1.25A1.28,1.28,0,0,1,41.09,309.68Zm-.61,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,40.48,309.68Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.33,309.54v1.35h-.62v-1.35c0-.37-.18-.55-.52-.55a.81.81,0,0,0-.54.19v1.71H42v-2.41h.61v.15a1.16,1.16,0,0,1,.65-.2C44,308.43,44.33,308.76,44.33,309.54Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,309.5a5.44,5.44,0,0,1-.48.71l.38.37-.37.34-.35-.34a1.31,1.31,0,0,1-.83.34c-.72,0-1.18-.33-1.18-.91a.92.92,0,0,1,.66-.83.83.83,0,0,1-.28-.61.89.89,0,0,1,1.77-.06.94.94,0,0,1-.67.85l.54.51a3.78,3.78,0,0,0,.36-.51Zm-1.14.74-.7-.69c-.25.1-.37.26-.37.44s.21.44.59.44A.78.78,0,0,0,48.85,310.24Zm-.79-1.65a.65.65,0,0,0,.27.45c.2-.06.47-.21.47-.45a.38.38,0,0,0-.38-.42A.39.39,0,0,0,48.06,308.59Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.13,307.76h.69l-1.46,3.13h-.29l-1.46-3.13h.69l.92,2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.6,307.86a.36.36,0,1,1,.71,0,.36.36,0,1,1-.71,0Zm0,.62h.62v2.41h-.62Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.45,310.24a2,2,0,0,0,.82.19c.29,0,.4-.11.4-.23s-.14-.2-.51-.28-.9-.28-.9-.75.36-.74.92-.74a2.33,2.33,0,0,1,.94.2l-.2.45a2.27,2.27,0,0,0-.75-.15c-.24,0-.36.08-.36.21s.15.19.53.27c.56.12.89.32.89.75s-.35.76-1,.76a2.08,2.08,0,0,1-1-.23Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.59,308.48v2.41H63v-.18a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.43,1.43,0,0,1,.71.2v-.15Zm-.62.72a.93.93,0,0,0-.6-.21.69.69,0,1,0,0,1.38.91.91,0,0,0,.6-.21Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69,310c0,.6-.49,1-1.21,1a2.43,2.43,0,0,1-1.31-.3l.24-.49a2.21,2.21,0,0,0,1.09.24c.34,0,.54-.13.54-.36s-.2-.3-.66-.41c-.65-.15-1.17-.33-1.17-.94s.44-.95,1.16-.95a3,3,0,0,1,1.2.26l-.26.5a2.85,2.85,0,0,0-1-.21c-.32,0-.5.15-.5.34s.22.32.69.42C68.53,309.18,69,309.4,69,310Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.45,309.86a.68.68,0,0,0,.69.54.78.78,0,0,0,.62-.3l.4.33a1.35,1.35,0,0,1-1.09.49,1.25,1.25,0,0,1,0-2.49,1.16,1.16,0,0,1,1.17,1.29v.14Zm0-.4h1.19a.53.53,0,0,0-.58-.53A.62.62,0,0,0,70.46,309.46Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.81,308.82a.91.91,0,0,1,.76-.39l.15,0v.67a2.1,2.1,0,0,0-.3,0,.57.57,0,0,0-.61.63v1.16h-.63v-2.41h.63Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78,308.48l-1.15,2.41h-.3l-1.16-2.41h.65l.66,1.36.65-1.36Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.84,307.86a.36.36,0,1,1,.71,0,.36.36,0,1,1-.71,0Zm0,.62h.62v2.41h-.62Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.72,310.44a1.15,1.15,0,0,1-.93.48,1.25,1.25,0,1,1,0-2.49,1.18,1.18,0,0,1,.94.48l-.4.37a.65.65,0,0,0-.54-.29.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.08,309.86a.68.68,0,0,0,.69.54.78.78,0,0,0,.62-.3l.4.33a1.33,1.33,0,0,1-1.09.49,1.25,1.25,0,0,1,0-2.49,1.16,1.16,0,0,1,1.17,1.29v.14Zm0-.4h1.19a.53.53,0,0,0-.58-.53A.63.63,0,0,0,84.09,309.46Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.91,310.24a2.09,2.09,0,0,0,.83.19c.28,0,.4-.11.4-.23s-.14-.2-.52-.28-.89-.28-.89-.75.36-.74.92-.74a2.37,2.37,0,0,1,.94.2l-.21.45a2.18,2.18,0,0,0-.75-.15c-.23,0-.35.08-.35.21s.14.19.53.27c.56.12.88.32.88.75s-.35.76-1,.76a2.08,2.08,0,0,1-1-.23Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.52,284h-.59v1.67h-.35V284H85v-.35h1.53Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.69,283.6v2h-.34v-1.43l-.67,1-.67-1v1.43h-.34v-2h.38l.63,1,.64-1Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.17,288.85v.65a4.85,4.85,0,0,0-1.15-.62,4.31,4.31,0,0,0-1.49-.24,4.58,4.58,0,0,0-1.75.33,4.39,4.39,0,0,0-1.38.92,4.26,4.26,0,0,0-.91,1.37,4.45,4.45,0,0,0-.32,1.68,4.38,4.38,0,0,0,.32,1.66,4.19,4.19,0,0,0,2.29,2.29,4.59,4.59,0,0,0,1.75.34h.17a4.71,4.71,0,0,0,1.76-.33v-2.32h0a2.47,2.47,0,0,1-.81.51,2.7,2.7,0,0,1-.94.17,2.6,2.6,0,0,1-.4,0h0a2.46,2.46,0,0,1-.55-.14,2.24,2.24,0,0,1-.8-.51,2.26,2.26,0,0,1,0-3.31,2.38,2.38,0,0,1,.8-.51,2.55,2.55,0,0,1,.95-.18,2.45,2.45,0,0,1,1.75.69,2.2,2.2,0,0,1,.72,1.66v4.29h2.06v-8.38Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.45,297.23l-4.56-4.41v4.41H17.83V285.62h2.06V290l4.56-4.37h2.92l-6,5.78,6,5.81Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.58,288.64a3.8,3.8,0,0,1,1.53.3,3.41,3.41,0,0,1,1.17.83A3.69,3.69,0,0,1,44,291a4.15,4.15,0,0,1,.26,1.5v4.73h-2V292.5a1.74,1.74,0,0,0-.6-1.35,2,2,0,0,0-1.41-.56,2,2,0,0,0-1.43.56,1.82,1.82,0,0,0-.58,1.35v4.73H36.17v-8.36h2.06v.62a4.22,4.22,0,0,1,1.05-.62A3.58,3.58,0,0,1,40.58,288.64Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.49,288.87a3.57,3.57,0,0,1,1.38-.25v2a2.46,2.46,0,0,0-1.75.68,2.28,2.28,0,0,0-.72,1.66v4.31H65.34v-8.38H67.4v.64A4.29,4.29,0,0,1,68.49,288.87Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.53,288.64a4.72,4.72,0,0,1,1.77.33,4.67,4.67,0,0,1,1.44.92,4.43,4.43,0,0,1,1,1.37,4.11,4.11,0,0,1,.35,1.68,4.05,4.05,0,0,1-.35,1.66,4.43,4.43,0,0,1-1,1.37,4.49,4.49,0,0,1-1.44.92,4.78,4.78,0,0,1-3.54,0,4.49,4.49,0,0,1-1.44-.92,4.43,4.43,0,0,1-1-1.37,4.05,4.05,0,0,1-.35-1.66,4.11,4.11,0,0,1,.35-1.68,4.43,4.43,0,0,1,1-1.37,4.67,4.67,0,0,1,1.44-.92A4.72,4.72,0,0,1,74.53,288.64Zm0,1.95a2.43,2.43,0,0,0-1.75.69,2.26,2.26,0,0,0,0,3.31,2.24,2.24,0,0,0,.8.51,2.75,2.75,0,0,0,1,.17,2.66,2.66,0,0,0,.94-.17,2.47,2.47,0,0,0,.81-.51,2.26,2.26,0,0,0,0-3.31A2.52,2.52,0,0,0,74.53,290.59Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.16,288.64a4.72,4.72,0,0,1,1.77.33,4.67,4.67,0,0,1,1.44.92,4.27,4.27,0,0,1,1,1.37,4,4,0,0,1,.35,1.68,3.9,3.9,0,0,1-.35,1.66,4.27,4.27,0,0,1-1,1.37,4.49,4.49,0,0,1-1.44.92,4.75,4.75,0,0,1-3.53,0A4.49,4.49,0,0,1,81,296a4.12,4.12,0,0,1-1-1.37,3.9,3.9,0,0,1-.36-1.66,4,4,0,0,1,.36-1.68,4.12,4.12,0,0,1,1-1.37,4.59,4.59,0,0,1,3.2-1.25Zm0,1.95a2.45,2.45,0,0,0-1.75.69,2.26,2.26,0,0,0,0,3.31,2.33,2.33,0,0,0,.8.51,2.8,2.8,0,0,0,1,.17,2.71,2.71,0,0,0,1-.17,2.42,2.42,0,0,0,.8-.51,2.24,2.24,0,0,0,0-3.31A2.5,2.5,0,0,0,84.16,290.59Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.14,288.85v.65a4.66,4.66,0,0,0-1.15-.62,4.27,4.27,0,0,0-1.49-.24,4.49,4.49,0,0,0-1.74.33,4.39,4.39,0,0,0-1.38.92,4.31,4.31,0,0,0-1.24,3.05,4.2,4.2,0,0,0,.33,1.66,4.19,4.19,0,0,0,2.29,2.29,4.5,4.5,0,0,0,1.74.34h.17a4.67,4.67,0,0,0,1.76-.33v-2.32h0a2.53,2.53,0,0,1-.8.51,2.75,2.75,0,0,1-.95.17,2.69,2.69,0,0,1-.4,0h0a2.61,2.61,0,0,1-.55-.14,2.33,2.33,0,0,1-.8-.51,2.26,2.26,0,0,1,0-3.31,2.48,2.48,0,0,1,.8-.51,2.55,2.55,0,0,1,1-.18,2.43,2.43,0,0,1,1.75.69,2.2,2.2,0,0,1,.72,1.66v4.29H64.2v-8.38Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.16,288.85v.65a4.66,4.66,0,0,0-1.15-.62,4.22,4.22,0,0,0-.74-.19,6.18,6.18,0,0,0-.89-.07,4.16,4.16,0,0,0-1.7.34,4,4,0,0,0-1.34.92,4.22,4.22,0,0,0-.87,1.37,4.63,4.63,0,0,0-.31,1.67h0a4.2,4.2,0,0,0,.33,1.66,4.19,4.19,0,0,0,2.29,2.29,4.5,4.5,0,0,0,1.74.34h.3a4.64,4.64,0,0,0,1.63-.32v-2.32h0a2.53,2.53,0,0,1-.8.51,2.75,2.75,0,0,1-1,.17,2.69,2.69,0,0,1-.4,0h0a2.61,2.61,0,0,1-.55-.14,2.33,2.33,0,0,1-.8-.51,2.27,2.27,0,0,1-.55-2.52l0-.07a2.35,2.35,0,0,1,.52-.72,2.48,2.48,0,0,1,.8-.51,2.55,2.55,0,0,1,.95-.18,2.43,2.43,0,0,1,1.75.69A2.35,2.35,0,0,1,52,292l0,.07a2.08,2.08,0,0,1,.17.87v3.26a2.21,2.21,0,0,1-.72,1.65,2.41,2.41,0,0,1-1.75.7,2.31,2.31,0,0,1-1.23-.33l-1.5,1.4a4.77,4.77,0,0,0,1.27.65,4.42,4.42,0,0,0,1.46.23,4.54,4.54,0,0,0,1.77-.34,4.69,4.69,0,0,0,1.44-.93,4.27,4.27,0,0,0,1-1.37,4.05,4.05,0,0,0,.35-1.66v-7.35Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.22,304.31v.55H17.83v-3.12h2.3v.55H18.44v.79h1.41v.53H18.44v.7Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.17,301.48v3.34h-.62v-.15a1.36,1.36,0,0,1-.7.19,1.25,1.25,0,0,1,0-2.49,1.45,1.45,0,0,1,.7.18v-1.07Zm-.62,2.61v-1a.91.91,0,0,0-.59-.2.68.68,0,0,0-.71.69.67.67,0,0,0,.71.68A.88.88,0,0,0,23.55,304.09Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.1,302.42v2.4h-.62v-.16a1.09,1.09,0,0,1-.65.2c-.71,0-1-.33-1-1.11v-1.33h.62v1.33c0,.37.18.56.52.56a.86.86,0,0,0,.54-.19v-1.7Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.88,304.38a1.15,1.15,0,0,1-.93.48,1.24,1.24,0,1,1,0-2.48,1.16,1.16,0,0,1,.94.47l-.4.37a.67.67,0,0,0-.54-.29.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.82,302.42v2.4h-.61v-.17a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.43,1.43,0,0,1,.71.2v-.15Zm-.61.72a.9.9,0,0,0-.59-.21.69.69,0,1,0,0,1.38.9.9,0,0,0,.59-.21Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.23,302.93v.85c0,.43.07.55.38.55l.29,0v.46a1.54,1.54,0,0,1-.56.09.7.7,0,0,1-.73-.76v-1.17h-.34v-.51h.34v-.93h.62v.93h.68v.51Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.37,301.84a.36.36,0,1,1,.36.36A.36.36,0,0,1,40.37,301.84Zm.05.62H41v2.4h-.62Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.22,303.62a1.32,1.32,0,1,1-1.31-1.24A1.28,1.28,0,0,1,45.22,303.62Zm-.61,0a.69.69,0,0,0-.7-.69.69.69,0,1,0,0,1.38A.69.69,0,0,0,44.61,303.62Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.05,303.52v1.34h-.62v-1.34c0-.37-.18-.55-.52-.55a.8.8,0,0,0-.53.19v1.7h-.61v-2.4h.61v.15a1.08,1.08,0,0,1,.64-.2C48.73,302.41,49.05,302.74,49.05,303.52Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.87,302.29v1.11h1.49V304H53.87v.91h-.61v-3.12h2.35v.55Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.58,303.62a1.32,1.32,0,1,1-1.31-1.24A1.28,1.28,0,0,1,59.58,303.62Zm-.61,0a.69.69,0,0,0-.7-.69.69.69,0,1,0,0,1.38A.69.69,0,0,0,59,303.62Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.4,302.42v2.4h-.62v-.16a1.11,1.11,0,0,1-.65.2c-.71,0-1-.33-1-1.11v-1.33h.61v1.33a.49.49,0,0,0,.53.56.86.86,0,0,0,.54-.19v-1.7Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.34,303.52v1.34h-.61v-1.34a.48.48,0,0,0-.53-.55.8.8,0,0,0-.53.19v1.7h-.61v-2.4h.61v.15a1.08,1.08,0,0,1,.64-.2C67,302.41,67.34,302.74,67.34,303.52Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.4,301.48v3.34h-.62v-.15a1.36,1.36,0,0,1-.7.19,1.25,1.25,0,0,1,0-2.49,1.45,1.45,0,0,1,.7.18v-1.07Zm-.62,2.61v-1a.93.93,0,0,0-.59-.2.68.68,0,0,0-.71.69.67.67,0,0,0,.71.68A.9.9,0,0,0,70.78,304.09Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.47,302.42v2.4h-.62v-.17a1.26,1.26,0,0,1-.7.21,1.25,1.25,0,0,1,0-2.49,1.39,1.39,0,0,1,.7.2v-.15Zm-.62.72a.9.9,0,0,0-.59-.21.69.69,0,1,0,0,1.38.9.9,0,0,0,.59-.21Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.88,302.93v.85c0,.43.07.55.38.55l.28,0v.46a1.48,1.48,0,0,1-.56.09.69.69,0,0,1-.72-.76v-1.17h-.34v-.51h.34v-.93h.62v.93h.67v.51Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80,301.84a.36.36,0,0,1,.35-.36.36.36,0,0,1,0,.72A.36.36,0,0,1,80,301.84Zm0,.62h.61v2.4h-.61Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.87,303.62a1.32,1.32,0,1,1-1.32-1.24A1.28,1.28,0,0,1,84.87,303.62Zm-.61,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,84.26,303.62Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.69,303.52v1.34h-.61v-1.34c0-.37-.18-.55-.52-.55a.76.76,0,0,0-.53.19v1.7h-.62v-2.4H87v.15a1.06,1.06,0,0,1,.64-.2C88.37,302.41,88.69,302.74,88.69,303.52Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 425.32,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 319.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 354.46,
    y1: 0.13,
    x2: 354.46,
    y2: 319.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.56,
    y1: 0.13,
    x2: 35.56,
    y2: 319.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 70.99,
    y1: 0.13,
    x2: 70.99,
    y2: 319.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 106.42,
    y1: 0.13,
    x2: 106.42,
    y2: 319.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 141.86,
    y1: 0.13,
    x2: 141.86,
    y2: 319.02
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 177.29,
    y1: 0.13,
    x2: 177.29,
    y2: 319.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 212.72,
    y1: 0.13,
    x2: 212.72,
    y2: 319.02
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 248.16,
    y1: 0.13,
    x2: 248.16,
    y2: 319.02
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 283.59,
    y1: 0.13,
    x2: 283.59,
    y2: 319.02
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 319.02,
    y1: 0.13,
    x2: 319.02,
    y2: 319.02
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 17.84,
    y1: 0.13,
    x2: 17.84,
    y2: 319.02
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.27,
    y1: 0.13,
    x2: 53.27,
    y2: 319.02
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 88.71,
    y1: 0.13,
    x2: 88.71,
    y2: 319.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 124.14,
    y1: 0.13,
    x2: 124.14,
    y2: 319.02
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 159.57,
    y1: 0.13,
    x2: 159.57,
    y2: 319.02
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 195.01,
    y1: 0.13,
    x2: 195.01,
    y2: 319.02
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 230.44,
    y1: 0.13,
    x2: 230.44,
    y2: 319.02
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 265.87,
    y1: 0.13,
    x2: 265.87,
    y2: 319.02
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 301.31,
    y1: 0.13,
    x2: 301.31,
    y2: 319.02
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 336.74,
    y1: 0.13,
    x2: 336.74,
    y2: 319.02
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 319.02,
    x2: 425.32,
    y2: 319.02
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 283.59,
    x2: 425.32,
    y2: 283.59
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 248.16,
    x2: 425.32,
    y2: 248.16
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 212.72,
    x2: 425.32,
    y2: 212.72
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 177.29,
    x2: 425.32,
    y2: 177.29
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 141.86,
    x2: 425.32,
    y2: 141.86
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 106.42,
    x2: 425.32,
    y2: 106.42
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 70.99,
    x2: 425.32,
    y2: 70.99
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 35.56,
    x2: 425.32,
    y2: 35.56
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 301.31,
    x2: 425.32,
    y2: 301.31
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 265.87,
    x2: 425.32,
    y2: 265.87
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 230.44,
    x2: 425.32,
    y2: 230.44
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 195.01,
    x2: 425.32,
    y2: 195.01
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 159.57,
    x2: 425.32,
    y2: 159.57
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 124.14,
    x2: 425.32,
    y2: 124.14
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 88.71,
    x2: 425.32,
    y2: 88.71
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 53.27,
    x2: 425.32,
    y2: 53.27
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 17.84,
    x2: 425.32,
    y2: 17.84
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 389.89,
    y1: 0.13,
    x2: 389.89,
    y2: 319.02
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 425.32,
    y1: 0.13,
    x2: 425.32,
    y2: 319.02
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 372.17,
    y1: 0.13,
    x2: 372.17,
    y2: 319.02
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 407.61,
    y1: 0.13,
    x2: 407.61,
    y2: 319.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial16);
export default __webpack_public_path__ + "static/media/guideMaterial16.55055de99b6b91f202fec305439ff575.svg";
export { ForwardRef as ReactComponent };